export type ActiveInput = 'nav' | 'chat'

let current: ActiveInput = 'nav'
const listeners = new Set<(val: ActiveInput) => void>()

export function getActiveInput(): ActiveInput {
  return current
}

export function setActiveInput(val: ActiveInput) {
  if (current === val) return
  current = val
  listeners.forEach((fn) => fn(current))
}

export function subscribeActiveInput(fn: (val: ActiveInput) => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
